import { FormInstance } from 'antd/lib/form';
import type { FormTextEditorProps } from '../templates/FormTextEditor';
import FormTextEditor from '../templates/FormTextEditor';

interface Conclusion<T> extends Omit<FormTextEditorProps<T>, 'content'> {
  form: FormInstance;
  editItem: string;
  height?: number;
}

const Conclusion = <T,>({
  name = 'conclusion',
  label = 'Conclusion',
  placeholder = 'Enter Conclusion',
  rules,
  required = true,
  form,
  editItem,
  height,
  ...props
}: Conclusion<T>) => {
  return (
    <FormTextEditor
      content={editItem}
      {...{ name, label, placeholder, form, required, rules, height }}
      {...props}
    />
  );
};

export default Conclusion;
